import React from 'react'
import {Button, Icon, Modal} from '@therms/atalaya'
import {generatePath} from 'react-router-dom'
import {USERS_ROUTES} from '@src/modules/Users/constants'
import {useUser} from '@therms/react-modules'
import {UserInfo} from '@src/modules/Users/components/UserInfo'
import {history} from '@src/App'
import {MdOpenInNew} from 'react-icons/md'

interface UserInfoModalProps {
  closeHandler: () => void
  userId: string
}

function UserInfoModal({closeHandler, userId}: UserInfoModalProps) {
  const {data} = useUser({userId})

  const user = data?.user

  return (
    <Modal
      closeHandler={closeHandler}
      escPressClose
      header={
        <div className="inline-flex w-full items-center justify-between">
          <span className="text-lg">User</span>

          <Button
            className="cursor-pointer"
            onClick={() => {
              history.push(
                generatePath(USERS_ROUTES.VIEW_USER, {
                  userId: user?.id,
                }),
              )
              closeHandler()
            }}
            subtle
            variant="main"
          >
            <Icon Icon={MdOpenInNew} size="sm" />
          </Button>
        </div>
      }
      width="lg"
    >
      {!!user && <UserInfo user={user} />}
    </Modal>
  )
}

export {UserInfoModal}